import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './style.css';
import { EVENT_TYPES } from '../../options';

const EventActions = ({ onTypeSelect }) => (
  <div className="event-actions">
    <span className="label">Add new:</span>
    <ul>
      {Object.keys(EVENT_TYPES).map((type, index) => (
        <li key={index}>
          <HoverableActionButton type={type} onTypeSelect={onTypeSelect} />
        </li>
      ))}
    </ul>
  </div>
);

EventActions.propTypes = {
  onTypeSelect: PropTypes.func.isRequired,
};

const HoverableActionButton = ({ type, onTypeSelect }) => {
  const [isHovered, setIsHovered] = useState(false);
  const backgroundColor = isHovered ? EVENT_TYPES[type].hover_color : EVENT_TYPES[type].color;

  return (
    <div
      className="action-button"
      style={{ backgroundColor }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={() => onTypeSelect(type)}
    >
      {React.cloneElement(EVENT_TYPES[type].icon, { width: 34, height: 34 })}
      {EVENT_TYPES[type].label}
    </div>
  );
};

HoverableActionButton.propTypes = {
  onTypeSelect: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
};

export default EventActions;
